import { Component, OnInit, ViewChild, ElementRef, Directive, Renderer2 } from '@angular/core';
import { ROUTES } from '../.././sidebar/sidebar.component';
import { Router, ActivatedRoute, NavigationEnd, RoutesRecognized } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AuthService } from '../../authentication/authService';
import { filter, pairwise } from 'rxjs/operators';

var misc:any ={
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
}
declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'navbar-cmp',
    templateUrl: 'navbar.component.html'
})

export class NavbarComponent implements OnInit{
    private listTitles: any[];
    location: Location;
    private nativeElement: Node;
    private toggleButton;
    private sidebarVisible: boolean;
    private previousUrl: string = null;

    @ViewChild("navbar-cmp", {static: true}) button;

    constructor(location:Location, private renderer : Renderer2, private element : ElementRef, private authService: AuthService, private router: Router) {
        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;
    }

    goBack(){
        this.router.navigate([this.previousUrl])
    }

    ngOnInit(){
        this.router.events
        .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
        .subscribe((events: RoutesRecognized[]) => {
            this.previousUrl = events[0].urlAfterRedirects;
        });
        this.listTitles = ROUTES.filter(listTitle => listTitle);

        var navbar : HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
        if($('body').hasClass('sidebar-mini')){
            misc.sidebar_mini_active = true;
        }
        $('#minimizeSidebar').click(function(){
            var $btn = $(this);

            if(misc.sidebar_mini_active == true){
                $('body').removeClass('sidebar-mini');
                misc.sidebar_mini_active = false;

            }else{
                setTimeout(function(){
                    $('body').addClass('sidebar-mini');

                    misc.sidebar_mini_active = true;
                },300);
            }

            // we simulate the window Resize so the charts will get updated in realtime.
            var simulateWindowResize = setInterval(function(){
                window.dispatchEvent(new Event('resize'));
            },180);

            // we stop the simulation of Window Resize after the animations are completed
            setTimeout(function(){
                clearInterval(simulateWindowResize);
            },1000);
        });
    }

    isMobileMenu(){
        if($(window).width() < 991){
            return false;
        }
        return true;
    }

    sidebarOpen(){
        var toggleButton = this.toggleButton;
        var body = document.getElementsByTagName('body')[0];
        setTimeout(function(){
            toggleButton.classList.add('toggled');
        },500);
        body.classList.add('nav-open');
        this.sidebarVisible = true;
    }
    sidebarClose(){
        var body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        body.classList.remove('nav-open');
    }
    sidebarToggle(){
        if(this.sidebarVisible == false){
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    }

    getTitle(){
      var titlee = this.location.prepareExternalUrl(this.location.path());
      if(titlee.charAt(0) === '#'){
          titlee = titlee.slice( 1 );
      }
        for (let i = 0; i < this.listTitles.length; i++) {
            if (this.listTitles[i].type === "link" && this.listTitles[i].path === titlee) {
                return this.listTitles[i].title;
            } else if (this.listTitles[i].type === "sub") {
                for (let j = 0; j < this.listTitles[i].children.length; j++) {
                    let subtitle = this.listTitles[i].path + '/' + this.listTitles[i].children[j].path;
                    if (subtitle == titlee) {
                        
                        return this.listTitles[i].children[j].title;
                    }
                    if(titlee.includes("pickOrderDetail")){
                        return "Pakbon"
                    }
                    if(titlee.includes("/mangelAdmin/admin/")){
                        return "Mangel"
                    }
                    if(titlee.includes("/prices/priceHistoryTotal/")){
                        return "Prijs historie"
                    }
                    if(titlee.includes("customer/invoice-data")){
                        return "Klant factuur kosten"
                    }
                    if(titlee.includes("customer/update")){
                        return "Klant wijzigen"
                    }
                    if(titlee.includes("/customer/leads/")){
                        return "Lead bewerken";
                    }
                    if(titlee.includes("/customer/info")){
                        return "Extra klant informatie"
                    }
                    if(titlee.includes("/invoiceDetail/")){
                        return "Factuur aanmaken"
                    }
                    if(titlee.includes("/invoice/invoice/")){
                        return "Print factuur"
                    }
                    if(titlee.includes("/pickOrder/orders/1")){
                        return "Alle pakbonnen"
                    }
                    if(titlee.includes("/pickOrder/orders")){
                        return "Laatste 500 pakbonnen"
                    }
                    if(titlee.includes("/invoice/openInvoice/")){
                        return "Open facturen per klant" 
                    }
                    if(titlee.includes("/customer/invoices/")){
                        return "Klant facturen" 
                    }
                    if(titlee.includes("/customer/packingslips/")){
                        return "Klant pakbonnen" 
                    }
                    if(titlee.includes("/packingSlip/")){
                        return "Pabkon detail"
                    }
                    if(titlee.includes("/customer/route/")){
                        return "Klant routes"
                    }
                    if(titlee.includes("/customer/attachments/")){
                        return "Bijlages"
                    }
                }
            }
        }
       // return 'Pakbon';
       return titlee
    }

    doLogout(){
        this.authService.logout();
    }

    getPath(){
        return this.location.prepareExternalUrl(this.location.path());
    }
}
